<template>
    <v-app id="us-v-app">
        <v-app-bar color="blue-grey" dense dark app>
            <v-btn icon @click="goBack">
                <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title style="font-size:1rem;">设备状态历史</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-app-bar>
        <v-content>
            <v-container style="font-size:0.9rem;">
              <StateHistory :iot-id="iotId" />
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import StateHistory from './components/StateHistory'
export default {
  components: { StateHistory },
  props: {},
  data() {
    return {
      iotId: ''
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    that.iotId = that.$route.query.iot_id
  },
  created() {
  },
  methods: {
    goBack() {
      var that = this;
      that.$router.back()
    }
  }
}
</script>

<style scoped>
</style>
